import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import OfferInsuranceProductRow from './OfferInsuranceProductRow';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

export const OfferInsuranceProductList = ({ products, companies, t, onProductPropertyChange }) => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>{t('Selected')}</TableCell>
        <TableCell>{t('OfferEdit.Insurance.Company')}</TableCell>
        <TableCell>{t('OfferEdit.Insurance.InsuranceType')}</TableCell>
        <TableCell align={'right'}>{t('OfferEdit.Insurance.Value')}</TableCell>
        <TableCell align={'right'}>{t('OfferEdit.Insurance.MonthlyValue')}</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {products.map((x, idx) => (
        <OfferInsuranceProductRow
          product={x}
          companies={companies}
          idx={idx}
          key={x.insuranceCompanyId}
          onProductPropertyChange={onProductPropertyChange(idx)}
        />
      ))}
    </TableBody>
  </Table>
);

OfferInsuranceProductList.propTypes = {
  products: PropTypes.array.isRequired,
  companies: PropTypes.array.isRequired,
  onProductPropertyChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(OfferInsuranceProductList);
